import React, { useState } from 'react';
import { Icon, useTheme } from '@Sage/hoi-poi-ui';
import MenuHoi from 'components/MenuHoi';

const WidgetAddIcon = () => {
    const [isHovered, setIsHovered] = useState(false);
    const theme = useTheme();

    return (
        <Icon
            name="addCircle"
            size="large"
            color={isHovered ? theme.colors.actionMajor[600] : theme.colors.actionMajor[500]}
            onMouseOver={() => setIsHovered(true)}
            onMouseOut={() => setIsHovered(false)}
        />
    );
};

const PopoverMenu = ({ actions, button }) => {
    return <MenuHoi items={actions}>{button}</MenuHoi>;
};

PopoverMenu.defaultProps = {
    button: <WidgetAddIcon />,
};

export default PopoverMenu;
